import { FC } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import IconUser from '@zvuk-b2b/react-uikit/ui/icons/User';
import IconFileText from '@zvuk-b2b/react-uikit/ui/icons/FileText';

import styles from './AcceptanceCredsMismatchErrorModal.module.scss';
import { TEXTS } from './texts';

const AcceptanceCredsMismatchErrorModal: FC<ModalProps[ModalTypes.ACCEPTANCE_CREDS_MISMATCH_ERROR]> = ({
  payerInn,
  payerName,
  companyInn,
  companyName,
  close,
}) => (
  <ModalScreen
    title={TEXTS.MODAL_TITLE}
    titlePlacement="left"
    onClose={close}
    actionButtons={[
      <Button
        key="button_acceptance_creds_mismatch_modal"
        elementId="button_acceptance_creds_mismatch_modal"
        type={ButtonType.PRIMARY}
        onClick={() => close()}>
        {TEXTS.MODAL_BUTTON_TEXT}
      </Button>,
    ]}>
    <div className={styles.description}>
      <span>{TEXTS.MODAL_DESCRIPTION}</span>
      <Info type={InfoTypes.ERROR}>{TEXTS.WARNING_TEXT}</Info>
      <span>{TEXTS.AFTER_WARNING_TEXT}</span>
      <div className={styles.credCardsContainer}>
        <div className={styles.credCard}>
          <div className={styles.credCardHeader}>
            <IconUser className={styles.credCardIcon} />
            <span>{TEXTS.COMPANY_SECTION_TITLE}</span>
          </div>
          <div className={styles.credGroup}>
            <span>
              {TEXTS.INN_LABEL} {companyInn}
            </span>
            <span>
              {TEXTS.NAME_LABEL} {companyName}
            </span>
          </div>
        </div>
        <div className={styles.credCard}>
          <div className={styles.credCardHeader}>
            <IconFileText className={styles.credCardIcon} />
            <span>{TEXTS.PAYER_SECTION_TITLE}</span>
          </div>
          <div className={styles.credGroup}>
            <span>
              {TEXTS.INN_LABEL} {payerInn}
            </span>
            <span>
              {TEXTS.NAME_LABEL} {payerName}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ModalScreen>
);

export default AcceptanceCredsMismatchErrorModal;
